import React from "react";
import {
  IoPeopleOutline,
  IoSearchOutline,
  IoCloseOutline,
  IoShieldCheckmarkOutline,
  IoTrashOutline,
} from "react-icons/io5";
import Person from "../Person";
import { ROLES, ROLE_LABELS } from "./constants";
import { stripAccents } from "../../utils/stripAccents";

export default function WorkspaceMembers({
  membres,
  loadingMembres,
  searchQuery,
  setSearchQuery,
  isAdmin,
  currentUserMembre,
  user,
  onRoleChange,
  onOpenPerms,
  onRemove,
}) {
  const filteredMembres = membres.filter((m) => {
    if (m.userId === user?.userId) return false;
    if (!searchQuery) return true;
    const q = stripAccents(searchQuery);
    return (
      stripAccents(m.nom).includes(q) ||
      stripAccents(m.prenom).includes(q) ||
      stripAccents(m.username).includes(q)
    );
  });

  return (
    <div className="card border-0 mb-4">
      <div className="card-header bg-transparent border-bottom d-flex align-items-center gap-2">
        <IoPeopleOutline size={20} />
        <h5 className="mb-0">Membres</h5>
      </div>
      <div className="card-body p-0">
        <div className="p-3 border-bottom">
          <div className="input-group">
            <span className="input-group-text bg-transparent">
              <IoSearchOutline />
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Rechercher un membre..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchQuery && (
              <button
                className="btn btn-outline-secondary"
                onClick={() => setSearchQuery("")}
              >
                <IoCloseOutline />
              </button>
            )}
          </div>
        </div>

        {loadingMembres ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status" />
          </div>
        ) : (
          <>
            {currentUserMembre && (
              <div className="d-flex align-items-center gap-3 p-3 border-bottom bg-light">
                <Person
                  person={{
                    image: user?.userImage,
                    nom: user?.nom,
                    prenom: user?.prenom,
                    colors: user?.color,
                    userId: user?.userId,
                  }}
                />
                <div className="flex-fill">
                  <strong>{user?.prenom} {user?.nom}</strong>
                  <br />
                  <small className="text-muted">Vous</small>
                </div>
                <span className="badge bg-primary text-capitalize">
                  {ROLE_LABELS[currentUserMembre.role] || currentUserMembre.role}
                </span>
              </div>
            )}

            {filteredMembres.length === 0 ? (
              <p className="text-center text-muted py-4 mb-0">
                {searchQuery
                  ? "Aucun membre trouvé."
                  : "Aucun autre membre."}
              </p>
            ) : (
              filteredMembres.map((membre) => (
                <div
                  key={membre._id}
                  className="d-flex align-items-center gap-3 p-3 border-bottom"
                >
                  <Person
                    person={{
                      image: membre.userImage,
                      nom: membre.nom,
                      prenom: membre.prenom,
                      colors: membre.color,
                      userId: membre.userId,
                    }}
                  />
                  <div className="flex-fill">
                    <strong>
                      {membre.prenom} {membre.nom}
                    </strong>
                    <br />
                    <small className="text-muted">
                      @{membre.username}
                    </small>
                  </div>
                  {isAdmin && (
                    <div className="d-flex align-items-center gap-2">
                      <select
                        className="form-select form-select-sm"
                        style={{ width: "auto" }}
                        value={membre.role}
                        onChange={(e) => onRoleChange(membre, e.target.value)}
                      >
                        {ROLES.map((r) => (
                          <option key={r} value={r}>
                            {ROLE_LABELS[r]}
                          </option>
                        ))}
                      </select>
                      <button
                        className="btn btn-sm btn-outline-primary"
                        title="Permissions"
                        onClick={() => onOpenPerms(membre)}
                      >
                        <IoShieldCheckmarkOutline />
                      </button>
                      <button
                        className="btn btn-sm btn-outline-danger"
                        title="Retirer"
                        onClick={() => onRemove(membre)}
                      >
                        <IoTrashOutline />
                      </button>
                    </div>
                  )}
                </div>
              ))
            )}
          </>
        )}
      </div>
    </div>
  );
}
